var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95898 2.29297V17.7096H16.0423V4.84352L13.4918 2.29297H3.95898ZM2.70898 2.16797C2.70898 1.54665 3.21267 1.04297 3.83398 1.04297H13.5435C13.8419 1.04297 14.1281 1.1615 14.339 1.37247L16.9628 3.99625C17.1738 4.20723 17.2923 4.49337 17.2923 4.79174V17.8346C17.2923 18.456 16.7886 18.9596 16.1673 18.9596H3.83398C3.21266 18.9596 2.70898 18.456 2.70898 17.8346V2.16797Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04232 8.33464C6.04232 7.98946 6.32214 7.70964 6.66732 7.70964L13.334 7.70964C13.6792 7.70964 13.959 7.98946 13.959 8.33464C13.959 8.67981 13.6792 8.95964 13.334 8.95964L6.66732 8.95964C6.32214 8.95964 6.04232 8.67981 6.04232 8.33464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04232 15.0013C6.04232 14.6561 6.32214 14.3763 6.66732 14.3763H13.334C13.6792 14.3763 13.959 14.6561 13.959 15.0013C13.959 15.3465 13.6792 15.6263 13.334 15.6263H6.66732C6.32214 15.6263 6.04232 15.3465 6.04232 15.0013Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04232 11.668C6.04232 11.3228 6.32214 11.043 6.66732 11.043H10.0007C10.3458 11.043 10.6257 11.3228 10.6257 11.668C10.6257 12.0131 10.3458 12.293 10.0007 12.293H6.66732C6.32214 12.293 6.04232 12.0131 6.04232 11.668Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.334 1.04297C13.6792 1.04297 13.959 1.32279 13.959 1.66797V4.3763H16.6673C17.0125 4.3763 17.2923 4.65612 17.2923 5.0013C17.2923 5.34648 17.0125 5.6263 16.6673 5.6263H13.834C13.2127 5.6263 12.709 5.12262 12.709 4.5013V1.66797C12.709 1.32279 12.9888 1.04297 13.334 1.04297Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.ea4a6dd148d5b30d611371ec9c587af5.svg";
export { ForwardRef as ReactComponent };